import { ApiEndpoints } from 'cng-common/configs/apiEndpoints'
import { checkCache, readFromCache, saveToCache } from 'core/classes/cache/Cache'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { Rest } from 'core/classes/http'
import settings from 'src/config/settings'

import { getTranslationStorageKey } from '../helpers/getTranslationStorageKey'
import { ILocale } from '../models'

export const getTranslations = async (locale: ILocale) => {
  const view = settings.translateView || '1352'
  const needRefresh = checkCache(getTranslationStorageKey(locale))
  if (needRefresh) {
    const data = await Rest.get({
      url: proxy(`${ApiEndpoints.translations.translationBase}/${view}/${locale && locale.value}`),
    })

    await saveToCache(getTranslationStorageKey(locale), data, true)
    return data
  } else {
    return readFromCache(getTranslationStorageKey(locale))
  }
}
